/*
 * 异常处理返回状态码
 * 格式 300X、500X
 *
 * @author miqiang
 * @date 2019-11-01
 */
export class ExceptionErrCode {

    /**
     * 生成报表异常
     */
    public static GENERATE_BAOBIAO_ERROR = 3001;

    /**
     * 上传文件异常
     */
    public static UPLOAD_FILE_ERROR = 3002;

    /**
     * 下载文件异常
     */
    public static DOWNLOAD_FILE_ERROR = 3003;

    /**
     * WebSocket消息发送失败
     */
    public static WSMESSAGE_SEND_FAIL = 3004;

    /**
     * WebSocket消息发送失败,已存储离线消息
     */
    public static WSMESSAGE_SEND_FAIL_SAVE = 3005;

    /**
     * 删除文件异常
     */
    public static DELETE_FILE_ERROR = 3006;

    /**
     * 用户未登录拦截异常
     */
    public static NOT_LOGIN_FILTER_EXCEPTION = 5000;

    /**
     * 系统发生未知异常
     */
    public static UNKOWN_EXCEPTION = 5001;

    /**
     * 请求被拦截异常
     */
    public static REQUEST_FILTER_EXCEPTION = 5002;

    /**
     * 数据库录入异常
     */
    public static DB_INSERT_EXCEPTION = 5003;

    /**
     * 数据库查询异常
     */
    public static DB_SELECT_EXCEPTION = 5004;

    /**
     * 数据库修改异常
     */
    public static DB_UPDATE_EXCEPTION = 5005;

    /**
     * 数据库删除异常
     */
    public static DB_DELETE_EXCEPTION = 5006;

    /**
     * 数据库操作异常
     */
    public static DB_EXCEPTION = 5007;

    /**
     * 数据库导出文件异常
     */
    public static DB_EXPORT_FILE_EXCEPTION = 5008;

    /**
     * Excel上传表头错误
     */
    public static EXCEL_HEADER_PARSER_ERROR = 5009;

    /**
     * Excel上传数据错误
     */
    public static EXCEL_UPLOAD_DATA_ERROR = 5010;

    /**
     * 文件下载异常
     */
    public static FILE_DOWNLOAD_ERROR = 5011;

    /**
     * zip压缩或解压异常
     */
    public static ZIP_FILE_ERROR = 5012;

    /**
     * HttpClient请求异常
     */
    public static SERVER_CALL_EXCEPTION = 5013;

    /**
     * 数据库有数据未处理完成或数据错误
     */
    public static DB_DATA_EXCEPTION = 5014;

    /**
     * Excel文件生成失败
     */
    public static EXCEL_GENERATE_ERR = 5015;

    /**
     * 需二次登陆响应码
     */
    public static TWO_LOGIN_FILTER_EXCEPTION = 6000;
}